import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import router from './core/router'
import App from './App.vue'
import { useAuthStore } from './core/stores/auth.store'
import { useSessionStore } from './core/stores/session.store'
import { useThemeStore } from './core/stores/theme.store'
import { onUnauthorized } from './core/api/client'
import ToteatDesignSystem from '@toteat-eng/design-system-vue'
import './styles/main.css'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
useThemeStore().initTheme()
app.use(router)
app.use(ToteatDesignSystem)

const authStore = useAuthStore()
const sessionStore = useSessionStore()
authStore.initializeAuth()

if (authStore.isAuthenticated) {
  authStore.refreshPermissions().catch(() => {})
}

onUnauthorized((reason) => {
  if (reason === 'http_401' || reason === 'token_expired') {
    sessionStore.showExpiredModal()
    return
  }

  if (authStore.isSessionExpired()) {
    sessionStore.showExpiredModal()
  }
})

watch(
  () => authStore.isAuthenticated,
  (isAuth) => {
    if (isAuth) {
      const expiresAt = authStore.getSessionExpiresAt()
      if (expiresAt) {
        sessionStore.startExpirationTimer(expiresAt, () => {
          authStore.logout()
          router.push('/login')
        })
      }
    } else {
      sessionStore.clearExpirationTimer()
    }
  },
  { immediate: true }
)

app.mount('#app')
